import React from "react";

const AboutOBZ = () => {
  const partnerLogos = [
    {
      id: 1,
      img: "/images/partner-logos/aws.svg",
      alt: "AWS",
      size: "w-20 h-7 md:w-24 md:h-7 lg:w-32 lg:h-7",
    },
    {
      id: 2,
      img: "/images/partner-logos/snowflake.svg",
      alt: "Snowflake",
      size: "w-20 h-8 md:w-24 md:h-10 lg:w-32 lg:h-10",
    },
    {
      id: 3,
      img: "/images/partner-logos/databricks.svg",
      alt: "Databricks",
      size: "w-20 h-8 md:w-24 md:h-10 lg:w-32 lg:h-10",
    },
    {
      id: 4,
      img: "/images/partner-logos/adobe.svg",
      alt: "Adobe",
      size: "w-20 h-6 md:w-24 md:h-6 lg:w-32 lg:h-6",
    },
    {
      id: 5,
      img: "/images/partner-logos/amdoc.svg",
      alt: "Amdocs",
      size: "w-20 h-6 md:w-24 md:h-6 lg:w-32 lg:h-6",
    },
    {
      id: 6,
      img: "/images/partner-logos/dbt.svg",
      alt: "dbt",
      size: "w-20 h-7 md:w-24 md:h-7 lg:w-32 lg:h-7",
    },
  ];

  return (
    <div className="w-full bg-gray-100 py-12 lg:py-18 relative">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 lg:mb-12">
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <h2 className="text-[32px] md:text-[40px] lg:text-[48px] xl:text-[56px] text-[#0A1931] RoobertLight leading-[120%] mb-2">
                About OBZ
              </h2>
              <h3 className="text-[20px] md:text-[22px] lg:text-[24px] xl:text-[28px] text-[#0A1931] RoobertMedium leading-[120%] mb-6">
                Built to deliver. Structured to scale.
              </h3>
            </div>
            <div className="hidden lg:block">
              <img
                src="/logo.png"
                alt="logo"
                className="w-32 h-32 object-contain"
              />
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="bg-white p-6 md:p-8 lg:p-12 rounded-lg shadow-lg relative">
          {/* Green L-shaped lines */}
          <div className="absolute top-0 right-0 w-24 md:w-28 lg:w-32 h-24 md:h-28 lg:h-32 border-t-2 border-r-2 border-[#66FF00]"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-x-24">
            {/* Content */}
            <div className="space-y-6">
              <p className="text-[16px] md:text-[17px] lg:text-[18px] text-black RoobertRegular leading-[140%]">
                OBZ is a consulting company designed around impact. Born in
                ASEAN, built on AWS.
              </p>
              <p className="text-[16px] md:text-[17px] lg:text-[18px] text-black RoobertRegular leading-[140%]">
                Our teams combine deep business expertise, data and AI delivery
                experience, and an expanding library of reusable agents and
                playbooks.
              </p>
              <p className="text-[16px] md:text-[17px] lg:text-[18px] text-black RoobertRegular leading-[140%]">
                Our diamond-shaped delivery model combines senior consultants,
                reusable IP, and AI coworkers working securely in your
                environment. We work side-by-side with your teams - building
                capability, not dependency.
              </p>
            </div>

            {/* Partner Logos */}
            <div className="grid grid-cols-2 gap-4 md:gap-6 gap-x-0 justify-center items-center">
              {partnerLogos.map((logo) => {
                return (
                  <img src={logo.img} alt={logo.alt} className={logo.size} />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutOBZ;
